import NotificationManager from './NotificationCenter/NotificationStore';

export function handleNotification(data, msg, title, type) {


    if (data.warnings && data.warnings.length > 0) {
        data.warnings.map((item, key) =>
            NotificationManager.warning((item.message || item.desc), item.code, 5000)
        )
    } else
    if (data.errors && data.errors.length > 0) {
        data.errors.map((item, key) =>
            NotificationManager.error((item.message || item.desc), item.code, 5000)
        )
    } else if (data.error ) {

        NotificationManager.error(data.error.error_details ? (Array.isArray(data.error.error_details) && data.error.error_details.length > 0 ? data.error.error_details.map(err => err.error_message).join(',') : data.error.error_details) : data.error.error_message || data.error.error, data.error.error_code, 5000)
        
    } else {
        if(type === 'info')
            NotificationManager.info(msg, title);
        else
            NotificationManager.success(msg, title, 5000);
    }
    
    return;
}